import React from 'react';

import { observer } from 'mobx-react-lite';

import { ViewByState } from '^/userWeb/Components/ViewByState';

import { StanzonePushSentTypeView } from './StanzonePushSentTypeView';
import { defaultStyles } from './StanzonesListPage.styles';
import { StanzonesListPageViewModel } from './StanzonesListPage.viewmodel';

export const StanzonesListPage: React.FC<{
  viewmodel: StanzonesListPageViewModel;
}> = observer(function StanzonesListPage(
  p,
) {
  const styles = defaultStyles;
  return (
    <div
      id="StanzonesListPageRoot"
      className={styles.pageRoot}
    >
      <h1>
        스탠존 알림 리스트 🔔
      </h1>
      <div
        className={styles.pageInner}
      >
        <ViewByState
          data={p.viewmodel.stanzonesList}
          loadingView={<></>}
          errorView={(e) => (
            <h2> {JSON.stringify(e)}</h2>
          )}
        >
          {(stanzonesByCamId) => {
            return (
              <div>
                {stanzonesByCamId
                  .entries()
                  .toArray()
                  .map(
                    (([camId, groupedStanzones]) => {
                      // const camId = keyValue.0;

                      const cam = p.viewmodel.camById(camId);
                      const camName = cam
                        ? `${cam.name}`
                        : `카메라_(${camId})_${JSON.stringify(cam)}`;
                      debugger;
                      // return (
                      //   <div
                      //     key={camId}
                      //   >
                      //     <h3>cam [{camName}]: {camId}</h3>
                      //     <pre>
                      //       {JSON.stringify(stanzones, null, 2)}
                      //     </pre>
                      //   </div>
                      // );

                      return (
                        <div
                          key={camId}
                          className={styles.itemRoot}
                        >
                          <h2
                            className={styles.itemCamName}
                          >
                            {camName}
                          </h2>
                          <div
                            className={styles.itemSlideRoot}
                          >
                            {groupedStanzones
                              .filter((s) => {
                                return s.isUp;
                              })
                              .map((stanzone) => {
                                const imgUrl = stanzone.imageUrl || '';
                                const isOpen = !stanzone.isUp;
                                const statusText = isOpen
                                  ? '열림 ✅'
                                  : '잠김 🔒';
                                return (
                                  <div
                                    key={stanzone.id}
                                    className={styles.itemSlideItem}
                                  >
                                    <img
                                      className={styles.itemSlideItemImage}
                                      alt=""
                                      src={imgUrl}
                                      loading="lazy"
                                    />
                                    <div
                                      className={styles.itemDescriptionTop}
                                    >
                                      <p>
                                        {stanzone.createdAt.toLocaleString()}
                                      </p>

                                      <div
                                        className={styles.itemGroupedCount}
                                      >
                                        🔔
                                      </div>
                                    </div>
                                    <div>
                                      <span>
                                        {statusText}
                                      </span>
                                      <StanzonePushSentTypeView
                                        stanzone={stanzone}
                                        eventTime={stanzone.createdAt}
                                      />

                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      );
                    }
                    ))}
              </div>
              //
            );
          }}
        </ViewByState>
      </div>
    </div>
  );
});
